module.exports = __webpack_public_path__ + "img/logo.ab3e2cba.svg";